var map = {
	"./afb-color.svg": 643,
	"./alb-color.svg": 644,
	"./all.svg": 645,
	"./amb-color.svg": 646,
	"./arg.svg": 647,
	"./aus.svg": 648,
	"./bank-icon.svg": 649,
	"./bankdemo-color.svg": 650,
	"./bel.svg": 651,
	"./bimb-color.svg": 652,
	"./bkr-color.svg": 653,
	"./bpay-color.svg": 654,
	"./bra.svg": 655,
	"./bsn-color.svg": 656,
	"./can.svg": 657,
	"./checked-white.png": 658,
	"./cimb-color.svg": 659,
	"./cimb-icon.svg": 660,
	"./citi-color.svg": 661,
	"./cmr.svg": 662,
	"./crc.svg": 663,
	"./cro.svg": 664,
	"./den.svg": 665,
	"./ecu.svg": 666,
	"./eng.svg": 667,
	"./esp.svg": 668,
	"./esports-active-m.svg": 669,
	"./esports-m.svg": 670,
	"./fav-gray.png": 671,
	"./fav-icon-active.png": 672,
	"./fav-icon.png": 673,
	"./fav-red.png": 674,
	"./fra.svg": 675,
	"./game-icon.svg": 676,
	"./games-active-m.svg": 677,
	"./games-m.svg": 678,
	"./ger.svg": 679,
	"./gha.svg": 680,
	"./gxbank-color.svg": 681,
	"./hlb-color.svg": 682,
	"./hlb-icon.svg": 683,
	"./hsbc-color.svg": 684,
	"./irn.svg": 685,
	"./jpn.svg": 686,
	"./kor.svg": 687,
	"./ksa.svg": 688,
	"./kwh-color.svg": 689,
	"./latest-icon-active.png": 690,
	"./latest-icon.png": 691,
	"./lc-active-m.svg": 692,
	"./lc-icon.svg": 693,
	"./lc-m.svg": 694,
	"./lottery-active-m.svg": 695,
	"./lottery-icon.svg": 696,
	"./lottery-m.svg": 697,
	"./love.svg": 698,
	"./mar.svg": 699,
	"./mbb-color.svg": 700,
	"./mex.svg": 701,
	"./ned.svg": 702,
	"./ocbc-color.svg": 703,
	"./ocbc-icon.svg": 704,
	"./p2p-active-m.svg": 705,
	"./p2p-icon.svg": 706,
	"./p2p-m.svg": 707,
	"./pbb-color.svg": 708,
	"./pol.svg": 709,
	"./por.svg": 710,
	"./price-high.svg": 711,
	"./price-low.svg": 712,
	"./qat.svg": 713,
	"./rhb-color.svg": 714,
	"./rhb-icon.svg": 715,
	"./scb-color.svg": 716,
	"./sen.svg": 717,
	"./slot-active-m.svg": 718,
	"./slot-icon.svg": 719,
	"./slot-m.svg": 720,
	"./speed-active-m.svg": 721,
	"./speed-m.svg": 722,
	"./sport-active-m.svg": 723,
	"./sport-m.svg": 724,
	"./sports-icon.svg": 725,
	"./square-icon.svg": 726,
	"./srb.svg": 727,
	"./star.svg": 728,
	"./sui.svg": 729,
	"./tng-color.svg": 730,
	"./trx-icon.svg": 731,
	"./trx.svg": 732,
	"./tun.svg": 733,
	"./uefa-icon.svg": 734,
	"./uob-color.svg": 735,
	"./uru.svg": 736,
	"./usa.svg": 737,
	"./usdc.svg": 738,
	"./usdt.svg": 739,
	"./ustd-icon.svg": 740,
	"./wal.svg": 741,
	"./x33-logo-b.svg": 742,
	"./x33-square-icon.svg": 743
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80;